//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AccountForm",
  props: {
    initialUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      user: {
        id: "",
        account: "",
        name: "",
        email: "",
        password: "",
        checkPassword: "",
      },
      isSetting: false,
    };
  },
  mounted() {
    this.state();
  },
  watch: {
    initialUser: function () {
      this.state();
    },
  },
  methods: {
    state() {
      if (this.$route.path === "/setting") {
        this.isSetting = true;
        this.user = {
          ...this.initialUser,
        };
      }
    },
    accountInfoSubmit() {
      this.$emit("account-info", this.user);
    },
  },
};
